"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateNeedCertificateRequirement = void 0;
const evaluateNeedCertificateRequirement = ({ requiredCertificates, operator, heldCertificateTypes, validCertificateTypes, }) => {
    if (requiredCertificates.length === 0) {
        return { isMet: true, isValid: true };
    }
    const satisfies = (predicate) => operator === 'OR' ? requiredCertificates.some(predicate) : requiredCertificates.every(predicate);
    const isMet = satisfies(documentType => heldCertificateTypes.has(documentType));
    const isValid = isMet && satisfies(documentType => validCertificateTypes.has(documentType));
    return { isMet, isValid };
};
exports.evaluateNeedCertificateRequirement = evaluateNeedCertificateRequirement;
